import { BrandFanFilters } from '@enums'
import { RefreshInfluencerIdentitiesSelfActionTypes } from '@store/brandFans'

export const refreshInfluencerIdentitiesSelf = (
  filter: BrandFanFilters.All | BrandFanFilters.BrandFans,
) => ({
  payload: filter,
  type: RefreshInfluencerIdentitiesSelfActionTypes.REFRESH_REQUEST,
})
